import React from 'react';

interface Brand {
  id?: number;
  brandName: string;
}

interface BrandTableProps {
  brands: Brand[];
  loading: boolean;
  onEdit: (brand: Brand) => void;
  onDelete: (id: number) => void;
}

const BrandTable: React.FC<BrandTableProps> = ({ brands, loading, onEdit, onDelete }) => {
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading brands...</p>
      </div>
    );
  }

  if (brands.length === 0) {
    return (
      <div className="empty-state">
        <p>No brands found. Click "Add New Brand" to create one.</p>
      </div>
    );
  }

  return (
    <div className="data-table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Brand Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {brands.map((brand) => (
            <tr key={brand.id}>
              <td>{brand.id}</td>
              <td>{brand.brandName}</td>
              <td className="table-actions">
                <button 
                  className="edit-button action-button"
                  onClick={() => onEdit(brand)}
                >
                  Edit
                </button>
                <button 
                  className="delete-button action-button"
                  onClick={() => brand.id && onDelete(brand.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BrandTable; 